<template>  
    <div class="selected-plan-wrapper">
        <div class="toggler-wrapper">
            <a href="#" class="toggleSelectedPlan" @click.prevent="showSelectedPlan = !showSelectedPlan">{{$t(( (!showSelectedPlan) ? 'SEE_PLAN' : 'HIDE_PLAN' ))}}</a>
        </div>

        <fieldset :class="{'show-plan': showSelectedPlan, 'hide-plan': !showSelectedPlan}">
            <legend visible="true" v-html="$t('SELECTED_PLAN')"></legend>        
            <div class="row line m-0">    
                <div v-if="form.selectedPlan" class="col-12" :key="$i18n.locale">                        
                    <h3 class="name">{{form.selectedPlan.name}}</h3>
                    <h3 class="mb-4 subtitle">{{form.selectedPlan.subtitle[$i18n.locale]}}</h3>

                    <div class="mb-4 fee-wrapper">
                        <p>{{$t('ADHESION_FEE')}}: <span>{{getFeePrice(form.selectedPlan)[( showDiscountedPrices ? 'price' : 'full_price' )]}}</span></p>
                        <p>{{$t('MONTHLY_PAYMENT')}}: <span>{{(getPlanFormattedPrices(form.selectedPlan))[( showDiscountedPrices ? 'price' : 'full_price' )]}}</span></p>                    
                    </div>

                    <div class="mb-4 payments-wrapper">
                        <p>{{$t('TOTAL_FIRST_PAYMENT')}}: <span><b>{{getFirstPaymentPrice(form.selectedPlan)[( showDiscountedPrices ? 'price' : 'full_price' )]}}</b></span></p>
                        <p>{{$t('NEXT_PAYMENTS')}}: <span><b>{{(getPlanFormattedPrices(form.selectedPlan))[( showDiscountedPrices ? 'price' : 'full_price' )]}}</b></span></p>
                        <p>{{$t('AGREEMENT_DURATION')}}: <span><b>{{form.selectedPlan.plan_details.agreement.duration}} {{$t(form.selectedPlan.plan_details.agreement.unit)}}</b></span></p>
                    </div>

                    <a href="#" @click.prevent="$bvModal.show('agreementModal')">{{$t('READ_AGREEMENT')}}</a>

                </div>
            </div>
            <b-modal size="lg" id="agreementModal" hide-header hide-footer centered>
                <div class="row line m-0 py-4 px-3">
                    <div class="col-12"> 
                        <h1 style="width: 100%;" class="mb-4 text-center" v-html="$t('AGREEMENT')"></h1>
                        <AgreementText></AgreementText>
                    </div>                               
                </div>
            </b-modal>
        </fieldset>
    </div>
</template>

<script>
import PlansMixin from '/src/mixins/PlansMixin'
import AgreementText from '../../common/AgreementText.vue'
export default {
    mixins: [PlansMixin],
    components:{    
        AgreementText,
    }, 
    data(){
        return {
            showSelectedPlan: true,
            agreement_text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil, cum! Ducimus accusantium praesentium aspernatur magnam, suscipit molestias! Recusandae cumque fugit nihil consequuntur dicta maxime excepturi sit, commodi soluta quo eveniet.",
        }
    },
    props: ['form']
}
</script>

<style scoped lang="scss">

.selected-plan-wrapper{

    .name,
    .subtitle{
        color: #2d77b3;
    }
    .fee-wrapper{
        width: 100%;    
        background-color: #F9B526;
        padding: 20px;
        p{
            color: #fff;
            margin: 0;
        }
    }
    .payments-wrapper{
        width: 100%;
        p{
            margin: 0;
            b{
                color: #2d77b3;
            }
        }
    }
    #agreement-text{
        width: 100%;
        resize: none;
    }
}

@media only screen and (min-width: 769px) {
    .toggler-wrapper{
        display: none;
    }
}

@media only screen and (max-width: 768px) {
    .toggler-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;

        .toggleSelectedPlan{
            width: 100%;
            text-align: center;
            margin-top: 20px;
        }
    }

    .show-plan{
        display: block;
        margin-top: 20px;
    }
    .hide-plan{
        display: none;
    }
}
@media only screen and (max-width: 768px) {

    .selected-plan-wrapper{

        .fee-wrapper, .payments-wrapper{
            span{
                display: block;
            }
        }
    }
    
}
</style>